var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// src/utils/hooks/useLanguage.ts
import { useTranslation } from 'react-i18next';
import '../../i18n'; // Import i18n configuration to ensure it's initialized
/**
 * A custom hook to provide translation functions and language control.
 * It encapsulates `useTranslation` from `react-i18next`.
 *
 * @param namespace Optional. The namespace(s) to load. Defaults to `defaultNS` from i18n config.
 * @returns An object containing `t` (translation function), `i18n` (i18next instance),
 * `changeLanguage` (function to change current language), `currentLanguage` (string), and `ready` (boolean).
 */
export var useLanguage = function (namespace) {
    var _a = useTranslation(namespace), t = _a.t, i18n = _a.i18n, ready = _a.ready;
    // Enhanced translation function that handles loading states and multiple namespaces
    var translate = function (key, options) {
        if (!ready) {
            if (t(key, options) === key) {
                return key;
            }
            else {
                return t(key, options);
            }
        }
        // If the key already has a namespace prefix (contains ':'), use it directly
        if (key.includes(':')) {
            return t(key, options);
        }
        // If multiple namespaces are provided, try each one until we find the key
        if (Array.isArray(namespace)) {
            for (var _i = 0, namespace_1 = namespace; _i < namespace_1.length; _i++) {
                var ns = namespace_1[_i];
                var namespacedKey = "".concat(ns, ":").concat(key);
                var translation = t(namespacedKey, __assign(__assign({}, options), { defaultValue: '__NOT_FOUND__' }));
                // If we found a valid translation (not the default value), return it
                if (translation !== '__NOT_FOUND__' && translation !== namespacedKey) {
                    return translation;
                }
            }
        }
        // Fallback to the original translation call without namespace prefix
        return t(key, options);
    };
    return {
        t: translate,
        ready: ready,
        language: i18n.language,
    };
};
